<template>
  <div :class="[cssClass, 'tooltip-class']">
    <div class="tooltip-class-title">
      <p class="text-left">{{ title }}</p>
    </div>
    <div class="tooltip-class-content text-left">
      <p v-for="(item, idx) of inclusions" :key="idx" class="tooltip-inclusion-row">
        <span class="tooltip-inclusion-icon">
          <img v-if="item.Icon === 'seat'"
               src="@/img/PassengerSeat-32x32.png"
               alt=""/>
          <font-awesome-icon v-else :icon="faIcon(item.Icon)"/>
        </span>
        <span class="tooltip-inclusion-label">{{ item.Label }}</span>
      </p>
      <p v-if="!inclusions || !inclusions.length" class="text-muted">
        {{ $t('Sin inclusiones adicionales.') }}
      </p>
    </div>
  </div>
</template>

<script>
  const CSS_BY_CLASS = {
    A: 'tooltip-basico',
    B: 'tooltip-medium',
    M: 'tooltip-premium',
  };
  const TITLE_BY_CLASS = {
    A: 'Tarifa básica incluye:',
    B: 'Tarifa intermedia incluye:',
    M: 'Tarifa premium incluye:',
  };
  const FA_ICONS = {
    briefcase: 'briefcase',
    sync: 'sync',
    undo: 'undo',
    refund: 'undo',
    check: 'check',
    seat: 'check',
  };

  export default {
    name: 'FareClassTooltipDetail',
    props: {
      productClassId: { type: String, required: true },
      fareRule: { type: Object, default: null },
    },
    computed: {
      cssClass: function () {
        return CSS_BY_CLASS[this.productClassId] || 'tooltip-basico';
      },
      title: function () {
        if (this.fareRule && this.fareRule.Title) return this.fareRule.Title;
        const raw = TITLE_BY_CLASS[this.productClassId] || 'Tarifa incluye:';
        return this.$t(raw);
      },
      inclusions: function () {
        return (this.fareRule && this.fareRule.Inclusions) || [];
      },
    },
    methods: {
      faIcon: function (icon) {
        return FA_ICONS[icon] || 'check';
      },
    },
  }
</script>
